import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';

// Scribe saves the clinic's templates only under the permission to edit the
// clinic's settings.
export const useCanEditTemplates = () => {
  const organization = useAppSelector(
    organizationModel.selectors.selectCurrentOrganization,
  );
  return organization?.YourPermissions?.CanEditSettings ?? false;
};
